import { useState } from 'react';

export default function CTA() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const body = new URLSearchParams();
      body.append('email', email);
      await fetch('https://readdy.ai/api/form/d6ep0dqff40lgbk6e26g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubscribed(true);
      setEmail('');
    } catch (err) {
      // Log the error for debugging; UI remains unchanged
      console.error('Newsletter subscription failed:', err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/82a9c4bce44faebe59ddc68a58a9e63e.jpg"
          alt="Houston Texas skyline - Data Health Insurance Consultants service area"
          title="Private health insurance coverage across Houston TX"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-navy-900/90 via-navy-900/85 to-navy-900/75"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h4 className="text-3xl md:text-4xl font-display font-bold text-white mb-4 leading-tight">
              <a
                href="#contact"
                className="text-white hover:text-brand-300 transition-colors"
              >
                Ready to Find Your Perfect Health Insurance Plan?
              </a>
            </h4>
            <p className="text-navy-200 text-base mb-6">
              Call us{' '}
              <strong className="text-brand-400">anytime</strong> at{' '}
              <a
                href="tel:7138049039"
                className="text-brand-400 font-semibold hover:text-brand-300 cursor-pointer"
              >
                (713) 804-9039
              </a>{' '}
              or visit our Houston office. Free consultations, expert advice,
              and plans from 50+ carriers.
            </p>
            <div className="flex flex-wrap gap-3">
              <a
                href="#contact"
                className="px-8 py-3.5 bg-brand-500 text-white text-sm font-semibold rounded-lg hover:bg-brand-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Get Free Quote
              </a>
              <a
                href="tel:7138049039"
                className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white text-sm font-semibold rounded-lg hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill text-brand-400"></i>
                </div>
                Call Now
              </a>
            </div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/10">
            <h3 className="text-white font-display font-bold text-lg mb-2">
              Stay Informed
            </h3>
            <p className="text-navy-300 text-sm mb-5">
              Get Houston health insurance tips and open enrollment updates.
            </p>
            {subscribed ? (
              <div className="flex items-center gap-2 text-brand-400 text-sm font-medium">
                <i className="ri-check-double-line text-lg"></i>
                Thank you! You&apos;re subscribed.
              </div>
            ) : (
              <form
                id="newsletter-form"
                data-readdy-form
                onSubmit={handleSubscribe}
                className="flex gap-2"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="Enter your email"
                  className="flex-1 px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-sm text-white placeholder-white/40 focus:outline-none focus:border-brand-400 transition-colors"
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="px-6 py-3 bg-brand-500 text-white text-sm font-semibold rounded-lg hover:bg-brand-600 transition-all duration-300 whitespace-nowrap cursor-pointer disabled:opacity-60"
                >
                  {submitting ? '...' : 'Subscribe'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
